// SPDX-FileCopyrightText: Copyright Orangebot, Inc. and Medplum contributors
// SPDX-License-Identifier: Apache-2.0
import type { Practitioner } from '@medplum/fhirtypes';
import { useMedplumProfile } from '@medplum/react';
import { type UseNotificationsResult, useNotificationsForRecipient } from '@polarissleep/messaging';

/** Provider-scoped wrapper around the shared notifications hook. */
export function useProviderNotifications(): UseNotificationsResult {
  const profile = useMedplumProfile() as Practitioner | undefined;
  const recipientRef = profile?.id ? `Practitioner/${profile.id}` : undefined;
  return useNotificationsForRecipient(recipientRef);
}
